import { useSelector } from "react-redux";

import {
  useAdminRegistrationMutation,
  useDeleteUserAccountMutation,
  useForgotPasswordMutation,
  useLoginMutation,
  useLogoutMutation,
  useResetPassMutation,
  useResetUserPassMutation,
} from "store/api/auth";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useAuthHook = () => {
  /** ***************** 
  @purpose : Used For handle get and reset data
  @Parameter : {data,reset}
  @Author : INIC
  ***************** */

  const [login, { data, isLoading, reset: resetLoginDetails }] =
    useLoginMutation({
      fixedCacheKey: fixedCacheKeys.LOGIN,
    });

  const [logoutUser, { reset: resetLogoutData }] = useLogoutMutation({
    fixedCacheKey: fixedCacheKeys.LOGOUT,
  });

  const [forgotPassword, { isLoading: forgotPassLoading }] =
    useForgotPasswordMutation({
      fixedCacheKey: fixedCacheKeys.FORGOT_PASSWORD,
    });

  const [resetPass, { isLoading: resetPassLoading, reset: resetPassword }] =
    useResetPassMutation({
      fixedCacheKey: fixedCacheKeys.RESET_PASSWORD,
    });

  const [resetUserPass, { isLoading: resetUserPassLoading }] =
    useResetUserPassMutation({
      fixedCacheKey: fixedCacheKeys.RESET_USER_PASSWORD,
    });

  const access_token = useSelector((state) => state.token.access_token);
  const resetAuthData = () => {
    resetLoginDetails();
    resetPassword();
  };
  const [adminRegistration, { isAdminRegiLoading }] =
    useAdminRegistrationMutation({
      fixedCacheKey: fixedCacheKeys.ADMIN_REGISTRATION,
    });

  const [deleteUserAccount] = useDeleteUserAccountMutation({
    fixedCacheKey: fixedCacheKeys.DELETE_USER_ACCOUNT,
  });

  return {
    adminRegistration,
    isAdminRegiLoading,
    login,
    data,
    isLoading,
    access_token,
    resetLoginDetails,
    logoutUser,
    forgotPassword,
    forgotPassLoading,
    resetPass,
    resetPassLoading,
    resetUserPass,
    resetUserPassLoading,
    resetAuthData,
    resetLogoutData,
    deleteUserAccount,
  };
};
